"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductStatusSkeleton = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const skeleton_and_no_data_state_styles_1 = require("./skeleton-and-no-data-state.styles");
const ProductStatusSkeleton = () => (react_1.default.createElement(skeleton_and_no_data_state_styles_1.SkeletonProductStatusContainer, null, react_1.default.createElement(skeleton_and_no_data_state_styles_1.StyledSkeletonWrapper, null, react_1.default.createElement(material_1.Skeleton, { height: "2.7rem", width: "45%" }), react_1.default.createElement(material_1.Skeleton, { height: "2.7rem", width: "45%" })), react_1.default.createElement(material_1.Skeleton, { variant: "circular", width: 180, height: 180 })));
exports.ProductStatusSkeleton = ProductStatusSkeleton;
exports.default = exports.ProductStatusSkeleton;
